export const URL = "https://betbackend-v5l5.onrender.com"